import React from "react";
import { connect } from "react-redux";
import PageHeaderWrapper from "../../components/PageHeaderWrapper";
import { TableComp } from "sz-react-utils";
import Request from "../../request";
import { Card, Col, Row, DatePicker } from "antd";
import moment from "moment";
let dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';
let { RangePicker } = DatePicker;
class CounsellorPerformanceReport extends React.Component {
    state = {
        counsellors: [],
        desks: [],
        ratings: [],
        total: 0,
        registrationTotal: 0,
        visaStatus: [],
        time: {
            key: "time",
            $gte: "",
            $lt: "",
        },
        registrationTime: {
            $gte: "",
            $lt: "",
        },
        counsellingTime: {
            $gte: "",
            $lte: "",
        },
    };

    constructor(props) {
        super(props);
        this.table = React.createRef();
    }

    apiRequest = (params) => {
        return new Promise(async (resolve) => {
            let response = await Request.getCounsellorPerformanceReport({
                ...params,
                InquiryDate: this.state.time,
                registrationTime: this.state.registrationTime,
                counsellingTime: this.state.counsellingTime,
            });
            let { counsellors, desks, ratings, visaStatus, total, registrationTotal } = response;
            this.setState({ counsellors, desks, ratings, visaStatus, total, registrationTotal });
            resolve(response);
        })
    }


    chooseRangerPicker = (date, dateString) => {
        this.state.showDate = true;

        if (!date || date.length === 0) {
            this.setState(
                {
                    time: {
                        key: "time",
                        $gte: "",
                        $lt: "",
                    },
                },
                () => this.reload()
            );
            return;
        }

        this.setState(
            {
                time: {
                    key: "time",
                    $gte: moment(date[0]).startOf('day'),
                    $lt: moment(date[1]).endOf('day'),
                },
            },
            () => this.reload()
        );
    };

    chooseRegistrationPicker = (date, dateString) => {
        this.state.showDate = true;

        if (!date || date.length === 0) {
            this.setState(
                {
                    registrationTime: {
                        $gte: "",
                        $lt: "",
                    },
                },
                () => this.reload()
            );
            return;
        }

        this.setState(
            {
                registrationTime: {
                    $gte: moment(date[0]).startOf('day'),
                    $lt: moment(date[1]).endOf('day'),
                },
            },
            () => this.reload()
        );
    };

    chooseCounsellingPicker = (date, dateString) => {
        this.state.showDate = true;

        if (!date || date.length === 0) {
            this.setState(
                {
                    counsellingTime: {
                        $gte: "",
                        $lt: "",
                    },
                },
                () => this.reload()
            );
            return;
        }

        this.setState(
            {
                counsellingTime: {
                    $gte: moment(date[0]).startOf('day'),
                    $lt: moment(date[1]).endOf('day'),
                },
            },
            () => this.reload()
        );
    };



    reload = () => {
        this.table.current.reload();
    };


    render() {
        let { counsellors, desks, ratings, total, visaStatus, registrationTotal } = this.state;
        const columns = [
            {
                title: 'Sr. No',
                key: 'serialNumber',
                render: (text, record, index) => (
                    <div>{index + 1}</div>
                )
            },
            {
                title: 'VID',
                key: 'id',
                searchTextName: 'VID',
            },
            {
                title: 'Student Name',
                key: 'studentName',
                searchTextName: 'Student Name',
            },
            {
                title: 'Counsellor Name',
                key: 'counsellorId',
                dataIndex: 'counsellorId.name',
                filters: counsellors
            },
            {
                title: 'Desk',
                key: 'atLevel',
                filters: desks,
                render: (text, record) => (
                    <div>{record && record.atLevel === "Front Desk" ? "Counselling Desk" : record.atLevel}</div>
                )
            },
            {
                title: 'Rating',
                key: 'rating',
                dataIndex: 'counsellingDesk.rating.ratingName',
                filters: ratings
            },
            {
                title: 'Date of Registration',
                key: 'registrationDate',
                render: (text, record) => (
                    <div>{record && record.moveDeskDate && record.moveDeskDate.moveToApplicationDesk ? moment(record.moveDeskDate.moveToApplicationDesk).format(dateFormat) : ""}</div>
                )
            },
            {
                title: 'Dropped',
                key: 'dropped',
                filters: [{ value: 'Yes', text: 'Yes' }, { value: 'No', text: 'No' }],
                render: (text, record) => (
                    <div>{record.dropped ? "Yes" : "No"}</div>
                )
            },
            {
                title: 'Visa Status',
                key: 'visaStatus',
                dataIndex: 'visaDesk.visaStatus',
                filters: visaStatus,
                render: (text, record) => (
                    <div>{record && record.visaDesk && record.visaDesk.visaStatus ? record.visaDesk.visaStatus : 'In Process'}</div>
                )
            }

        ]
        return (
            <PageHeaderWrapper title="Counsellor Performance Report">
                <Row>
                    <Card style={{ marginBottom: 10 }}>
                        <Col span={8}>
                            <h4>FILTER BY CREATED DATE</h4>
                            <RangePicker
                                key={this.state.showDate ? "78" : "326"}
                                showTime={{ format: "HH:mm" }}
                                format="YYYY-MM-DD"
                                placeholder={["Start Date", "End Date"]}
                                onChange={this.chooseRangerPicker}
                                onOk={this.onOk}
                            />
                        </Col>
                        <Col span={8}>
                            <h4>FILTER BY COUNSELLING DATE</h4>
                            <RangePicker
                                key={this.state.showDate ? "78" : "326"}
                                showTime={{ format: "HH:mm" }}
                                format="YYYY-MM-DD"
                                placeholder={["Start Date", "End Date"]}
                                onChange={this.chooseCounsellingPicker}
                                onOk={this.onOk}
                            />
                        </Col>
                        <Col span={8}>
                            <h4>FILTER BY REGISTRATION DATE</h4>
                            <RangePicker
                                key={this.state.showRegiDate ? "78" : "326"}
                                showTime={{ format: "HH:mm" }}
                                format="YYYY-MM-DD"
                                placeholder={["Start Date", "End Date"]}
                                onChange={this.chooseRegistrationPicker}
                                onOk={this.onRegistrationOk}
                            />
                        </Col>


                    </Card>
                </Row>
                <Row gutter={16} style={{ marginBottom: 16 }}>
                    <Col span={8}>
                        <Card
                            bordered
                            style={{
                                borderRadius: 12,
                                background: 'linear-gradient(135deg, #f0f5ff 0%, #d6e4ff 100%)',
                                boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
                            }}
                        >
                            <div style={{ textAlign: 'center' }}>
                                <div style={{ fontSize: 16, fontWeight: 600, color: '#1f1f1f' }}>Student Count</div>
                                <div style={{ fontSize: 28, fontWeight: 'bold', color: '#1677ff' }}>{total || 0}</div>
                            </div>
                        </Card>
                    </Col>

                    <Col span={8}>
                        <Card
                            bordered
                            style={{
                                borderRadius: 12,
                                background: 'linear-gradient(135deg, #f6ffed 0%, #d9f7be 100%)',
                                boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
                            }}
                        >
                            <div style={{ textAlign: 'center' }}>
                                <div style={{ fontSize: 16, fontWeight: 600, color: '#1f1f1f' }}>Registrations Count</div>
                                <div style={{ fontSize: 28, fontWeight: 'bold', color: '#389e0d' }}>{registrationTotal || 0}</div>
                            </div>
                        </Card>
                    </Col>

                    <Col span={8}>
                        <Card
                            bordered
                            style={{
                                borderRadius: 12,
                                background: 'linear-gradient(135deg, #fff1f0 0%, #ffa39e 100%)',
                                boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
                            }}
                        >
                            <div style={{ textAlign: 'center' }}>
                                <div style={{ fontSize: 16, fontWeight: 600, color: '#1f1f1f' }}>Conversion %</div>
                                <div style={{ fontSize: 28, fontWeight: 'bold', color: '#cf1322' }}>
                                    {total > 0 ? ((registrationTotal / total) * 100).toFixed(2) : 0}%
                                </div>
                            </div>
                        </Card>
                    </Col>
                </Row>

                <Card bordered={true}>
                    <TableComp
                        columns={columns}
                        ref={this.table}
                        apiRequest={this.apiRequest}
                        // extraProps={{ scroll: { x: 1400 } }}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 20,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>
            </PageHeaderWrapper>
        )
    }
}



const mapStateToProps = ({ global, router }) => ({
    categories: global.categories,
    search: router.location.search,
});

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    };
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CounsellorPerformanceReport);